Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createAnimatedPropAdapter = void 0;
var _ConfigHelper = require("../ConfigHelper");
var createAnimatedPropAdapter = exports.createAnimatedPropAdapter = function createAnimatedPropAdapter(adapter, nativeProps) {
    var nativePropsToAdd = {};
    nativeProps == null ? void 0 : nativeProps.forEach(function(prop) {
        nativePropsToAdd[prop] = true;
    });
    (0, _ConfigHelper.addWhitelistedNativeProps)(nativePropsToAdd);
    return adapter;
};
